const moment = require("moment");

module.exports = {
  status: {
    finished: {
      text: "Finalizado",
      color: "error"
    },
    pending: {
      text: "Pendente",
      color: "info"
    },
    active: {
      text: "Ativo",
      color: "success"
    },
  },
}
